import script from "./VVVApplications.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVApplications.vue?vue&type=script&setup=true&lang=js"

import "./VVVApplications.vue?vue&type=style&index=0&id=97ea74b4&scoped=true&lang=css"
import "./VVVApplications.vue?vue&type=style&index=1&id=97ea74b4&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97ea74b4"]])

export default __exports__